/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_ClickupInputs */



/**
* | output |
* | --- |
* | "ClickUp" |
*
* @param {Spaces_Provider_ClickupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_provider_clickup = /** @type {((inputs?: Spaces_Provider_ClickupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_ClickupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("ClickUp")
	return /** @type {LocalizedString} */ ("ClickUp")
});